<template>

    <section class="error-container">
      <div class="background"></div>
      <!-- <img :src='"../assets/logo.png"' alt="about" class="img-fluid" /> -->
    <div class="error-title-container">

    <h1>{{$lang.error.error_title}}</h1>
    <p>{{$lang.error.error_desc}}</p>
    <a class="back-home" @click="onClick">{{$lang.about.home }}</a>
    
    </div>
    </section>
</template>

<script>

export default {
  name: "ErrorPage",
  methods:{
    onClick(){
      
      const me = this
      me.$router.push({ name: 'taption' })
    }
  }

}

</script>

<style>
.error-container{
  height: calc(100vh - 100px);
  padding-top:100px;
  width:100%;
}
.error-container .background{
  position: fixed;
  width:inherit;
  height: calc(100vh - 100px);
  background:url(../assets/logo.png);
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  opacity: 0.15;
}
.error-title-container{
  padding-top: 100px;
    z-index: 0;
    position: absolute;
    width: 100%;
}
.error-container h1{
  font-size: 63px;
}
.error-container p{
  font-size: 23px;
  color:#797676;
}
.error-container img{
 position:absolute;
}
.error-container .back-home{
  cursor: pointer;

}
</style>